import { Link } from 'react-router-dom';

// Sits under the Buy buttons on product pages. A buyer worried that the site
// is fake sees the two real people who run Citi Cool, and one tap takes them
// to /about (showroom, Daikin meetings, certificates). Saheb chose this over a
// "check us before you pay" checklist (19 Oct 2026). No "family" wording.

const OWNERS = [
  { name: 'Hemant Sareen', image: '/media/p3yqcz6s-chatgpt-image-feb-26-2026-12-41-22-pm.webp', pos: 'object-top' },
  { name: 'Saheb Sareen', image: '/media/hjgs5aq5-image.webp', pos: '' },
];

export default function OwnersCard({ className = '' }) {
  return (
    <Link to="/about"
      className={`flex items-center gap-3 rounded-xl border border-gray-200 bg-white p-3 transition hover:border-blue-300 ${className}`}>
      <span className="flex shrink-0">
        {OWNERS.map((o, i) => (
          <img key={o.name} src={o.image} alt={o.name} loading="lazy" decoding="async"
            className={`h-12 w-12 rounded-full border-2 border-white bg-gray-100 object-cover shadow-sm ${o.pos} ${i ? '-ml-3.5' : ''}`} />
        ))}
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-bold text-gray-900">The people behind Citi Cool</span>
        <span className="mt-0.5 block text-xs leading-snug text-gray-600">Hemant Sareen, Founder · Saheb Sareen, Director</span>
        <span className="mt-1 block text-xs font-semibold text-blue-700">Meet us and see our showroom</span>
      </span>
      <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0 text-gray-400" fill="none" stroke="currentColor"
        strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
    </Link>
  );
}
